import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import './theme/index.css'
import store from './store'
import i18n from './lang'
import axios from 'axios'
// import * as VueGoogleMaps from 'vue2-google-maps'
import VueGtag from "vue-gtag";

Vue.use(VueGtag, {
  config: { 
    id: "UA-139106547-1",
    // pageTrackerTemplate(to) {
    //   console.log(to)
    //   return {
    //     page_title: 'PPPoker',
    //     page_path: to.path
    //   }
    // }
  }
}, router);

// Vue.use(VueGoogleMaps, {
//   load: {
//     key: 'AIzaSyBW00VkgA8JgG5MU_XdmcjjRdzbSZ7-SQg',
//     libraries: 'places', // This is required if you use the Autocomplete plugin
//     language: 'en-ph'
//   }
// })

axios.interceptors.request.use(config => {
  // 增加时间戳
  config.params = {
    _t: Date.parse(new Date()) / 1000,
    ...config.params
  }

  return config
}, error => {
  // 发送请求错误操作
  return Promise.reject(error)
})

axios.defaults.baseURL = process.env.VUE_APP_AXIOS
Vue.prototype.$axios = axios
Vue.config.productionTip = false
Vue.use(ElementUI, { locale })

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
